import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';
import {useInfiniteScroll} from "../../../hooks/useInfiniteScroll";
import {setComma, splitDateTime} from "../../../utils/format";
import InfiniteScrollSentinel from "../../../components/common/InfiniteScrollSentinel";
import {getMemberRefundList} from "../../../api/transaction/refundApi";
import {EmptyState} from "../../../components/common/EmptyStateProps";
import {OutletContextType} from "../../../types/common/oulet.comtext.types";

export default function RefundListPage() {
    const navigate = useNavigate();
    const {searchTypes, setTotalSize, searchTrigger} = useOutletContext<OutletContextType>();
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();

    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberRefundList({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size | 5);
                setTotalSize(response.data.data.totalSize || 0);
            }
        } catch (err) {
            console.error('잔액환불 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberRefundList({
                ...searchTypes,
                page: nextPage,
            });

            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size | 5);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };


    useEffect(() => {
        handleSearch();
    }, [searchTrigger]);


    return (
        <>
            {loading ? (
                <section className="bg-white no-gap">
                    <div className="inner-box">
                        <p>데이터를 불러오는 중...</p>
                    </div>
                </section>
            ) : !accumulatedRows || accumulatedRows.length === 0 ? (
                <EmptyState message="잔액환불 내역이 비어있습니다."/>
            ) : (
            <section className="bg-white no-gap">
                <div className="inner-box">
                    {accumulatedRows.map((item: any, index: number) => {

                        const isMinus = item.status == "COMPLETED";
                        const { date, time } = splitDateTime(item.regDate);
                        return (
                            <div
                                key={item.id}
                                className="payment-wrap"
                                onClick={() => navigate(`/wallet/refund-list/${item.refundRequestCode}`)}
                                style={{cursor: "pointer"}}
                            >
                                <div className="payment-info">
                                    <div className="info-row">
                                        <div className="time">
                                            {date}
                                            <em className="line">{time}</em>
                                        </div>
                                        <div className={isMinus ? "status finish" : "status"}>{item.statusDescription}</div>
                                    </div>
                                    <div className="info-row">
                                        <div className="cont">잔액환불</div>
                                        <div className={isMinus ? "amount text-red" : "amount"}>{isMinus ? "-" : ""}{setComma(item.refundableAmount)}원</div>
                                    </div>
                                    <div className="info-row">
                                        <div className="method">{item.refundMethod}</div>
                                    </div>
                                </div>
                            </div>
                        );}
                    )}
                </div>
            </section>
            )}
            <InfiniteScrollSentinel
                showMore={showMoreButton}
                loadingMore={loadingMore}
                loading={loading}
                onLoadMore={handleLoadMore}
            />
        </>
    );
}